import React, { useState, useEffect } from 'react'
import { format } from 'date-fns'
import Form from 'react-bootstrap/Form';
import ReactPaginate from 'react-paginate';
import TextTruncate from '../utilsComponent/textTruncate';
import ClaimDetail from './claimDetail';
import axios from 'axios';
import "../scss/claimHistory.scss";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { REACT_APP_VAM_CONTEXT_INGESTION,REACT_APP_VAM_ENDPOINT} from "../urls";
import LoadingPage from '../reusableComponents/loader/loadingPage';

import NoDataFound from '../utilsComponent/noDataFound';
import {getFromDecreaptLocalStorage } from '../utilFunctions';
import { REACT_APP_VAM_CONTEXT_DOCUMENT ,} from '../urls';
import { PAGE_NAME_KEYS } from '../consts';
const ClaimHistory = (props) => {
    const { productName, searchType, productID, searchValue, policySearch, loading, showClaimButtons, setShowClaimButtons, claimHistory, setClaimHistory, productNames } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [currentItems, setCurrentItems] = useState([])
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0);
    const [selectedPage, setSelectedPage] = useState(0)
    const [pageCount, setPageCount] = useState(0);
    const [navigateTo, setNavigateTo] = useState(false)
    const [claimIntimationLists, setClaimIntimationLists] = useState([])
    const [policyNumber, setpolicyNumber] = useState(0);
    const [sortedCauseDate, setSortedCauseDate] = useState(false)
    const [sortedIntimatDate, setSortedIntimatDate] = useState(false)
    const [claimCount, setClaimCount] = useState(0)
    const [document, setDocument] = useState();
    const [selectedOption, setSelectedOption] = useState();
    const claimDetailCookie = getFromDecreaptLocalStorage("claimDetail")
    const [loadingHistoryList, setLoadingHistoryList] = useState(false)

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(claimHistory.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(claimHistory.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, claimHistory]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % claimHistory.length;
        setItemOffset(newOffset);
        setSelectedPage(event.selected)
    };
    const itemPerChangeHandler = (count) => {
        setItemsPerPage(count)
        setItemOffset(0)
        setSelectedPage(0)
    }
    const getPathName = () => {
        setShowClaimButtons(false)
        return location.pathname.split("/")[location.pathname.split("/").length - 1]
    }
    // useEffect(() => {
    //     setCurrentItems(claimHistory);
    // }, [claimHistory]);
    const sortCauseDates = () => {
        let sortedDates = []
        if (sortedCauseDate) {
            sortedDates = claimHistory.sort(function (a, b) {
                return new Date(b.dateAndTimeOfLoss) - new Date(a.dateAndTimeOfLoss)
            });
            setSortedCauseDate(false)
        } else {
            sortedDates = claimHistory.sort(function (a, b) {
                return new Date(a.dateAndTimeOfLoss) - new Date(b.dateAndTimeOfLoss)
            });
            setSortedCauseDate(true)
        }
        setClaimHistory([...sortedDates])
    }
    const sortIntimateDates = () => {
        let sortedDates = []
        if (sortedIntimatDate) {
            sortedDates = claimHistory.sort(function (a, b) {
                return new Date(b.createdDate) - new Date(a.createdDate)
            });
            setSortedIntimatDate(false)
        } else {
            sortedDates = claimHistory.sort(function (a, b) {
                return new Date(a.createdDate) - new Date(b.createdDate)
            });
            setSortedIntimatDate(true)
        }
        setClaimHistory([...sortedDates])
    }
    return (
        <>
          {
            loading ? (
                <LoadingPage/>
            ) : (
                <>
                    {navigateTo && getPathName() === PAGE_NAME_KEYS.CLAIM_INTIMATION_DETAILS &&
                        (<ClaimDetail
                            //navigateclaimprocessing={navigateclaimprocessing}
                            claimCount={claimCount}
                            claimDetailCookie={claimDetailCookie}
                            claimIntimationLists={claimIntimationLists}
                            //searchType={searchFields.search_type.value}
                            productID={productID}
                            policyNumber={policyNumber}
                            document={document}
                            productNames={productNames}
                        >
                        </ClaimDetail>)
                    }
                    {
                        currentItems && currentItems.length > 0 && (
                            <>
                                {!navigateTo&&(
                                    loadingHistoryList ? <LoadingPage/> : 
                                    <div className='inner-box2Field  mt-3' >
                                        <div className="detailsHistory">
                                        <div className='d-flex align-items-end justify-content-between'>
                                            <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">Claim History</h3>
                                        </div>
                                        {
                                            claimHistory && claimHistory.length > 0 ? (
                                                <div className="row">
                                                    <section className="p-4">
                                                        <div className = "overflowHistory">
                                                            <table className="table table-strip mt-3 text-left">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Claim ID</th>
                                                                        <th scope="col">Cause of Loss</th>
                                                                        <th scope="col">Date & Time of peril occurance
                                                                            <span className="pointerPolicy" onClick={() => sortCauseDates()}>
                                                                                <img
                                                                                    src="/kshemaImages/Vector.png"
                                                                                    alt="dropdown vector"
                                                                                    width="auto"
                                                                                    height="8px"
                                                                                    className="pointer"
                                                                                />
                                                                            </span>
                                                                        </th>
                                                                        <th scope="col">Intimated Date and Time
                                                                            <span className="pointerPolicy" onClick={() => sortIntimateDates()}>
                                                                                <img
                                                                                    src="/kshemaImages/Vector.png"
                                                                                    alt="dropdown vector"
                                                                                    width="auto"
                                                                                    height="8px"
                                                                                    className="pointer"
                                                                                />
                                                                            </span>
                                                                        </th>
                                                                        <th scope="col">Claim Remarks</th>
                                                                        <th scope="col">Claim Stage</th>
                                                                        <th scope="col">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        currentItems && currentItems.length > 0 && currentItems.map(list => (
                                                                            <tr>
                                                                                <td><span className='text-primary pointer' onClick={() => {
                                                                                    policySearch(list.policy.policyNumber, list.policy.custemerID, list.claimNo, productName, productID)
                                                                                }}>{list.claimNo ? <TextTruncate text={list.claimNo} length={20} /> : "--"}</span></td>
                                                                                <td>{list.perilName ? <TextTruncate text={list.perilName} length={15} /> : "--"}</td>
                                                                                <td>{list?.dateAndTimeOfLoss ? format(new Date(list.dateAndTimeOfLoss.split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                                                <td>{list?.claimOpenDate ? format(new Date(list.claimOpenDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "--"}</td>
                                                                                <td>{list.claimRemarks ? <TextTruncate text={list.claimRemarks} length={15} /> : "--"}</td>
                                                                                <td>{list.claimSubstatus ? list.claimSubstatus : "--"}</td>
                                                                                <td>{list.claimStatus ? list.claimStatus : "--"}</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {
                                                            claimHistory.length > 0 && (
                                                                <div className="d-flex align-items-center justify-content-end">
                                                                    <div className="d-flex">
                                                                        Select Limit :
                                                                        <Form className="ms-3">
                                                                            {['radio'].map((type) => (
                                                                                <div key={`inline-${type}`} className="mb-3">
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="10"
                                                                                        name="group1"
                                                                                        type={type}
                                                                                        //checked={itemsPerPage == 10}
                                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                                                                                        id={`inline-${type}-1`}
                                                                                    >
                                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }}
                                                                                            onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                                                                                            checked={itemsPerPage == 10}
                                                                                        />
                                                                                        <Form.Check.Label >10</Form.Check.Label>
                                                                                    </Form.Check>
                                                                                    <Form.Check
                                                                                        inline
                                                                                        //label="25"
                                                                                        name="group1"
                                                                                        type={type}
                                                                                        //checked={itemsPerPage == 25}
                                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                                                                                        id={`inline-${type}-2`}
                                                                                    >
                                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }}
                                                                                            onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                                                                                            checked={itemsPerPage == 25}
                                                                                        />
                                                                                        <Form.Check.Label >25</Form.Check.Label>
                                                                                    </Form.Check>
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label="50"
                                                                                        name="group1"
                                                                                        type={type}
                                                                                        //checked={itemsPerPage == 50}
                                                                                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                                                                                        id={`inline-${type}-3`}
                                                                                    >
                                                                                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }}
                                                                                            onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                                                                                            checked={itemsPerPage == 50}
                                                                                        />
                                                                                        <Form.Check.Label >50</Form.Check.Label>
                                                                                    </Form.Check>
                                                                                </div>
                                                                            ))}
                                                                        </Form>
                                                                    </div>
                                                                    <ReactPaginate
                                                                        nextLabel=">>"
                                                                        onPageChange={(e) => handlePageClick(e)}
                                                                        pageRangeDisplayed={3}
                                                                        marginPagesDisplayed={2}
                                                                        pageCount={pageCount}
                                                                        forcePage={selectedPage}
                                                                        previousLabel="<<"
                                                                        pageClassName="page-item"
                                                                        pageLinkClassName="page-link"
                                                                        previousClassName="page-item"
                                                                        previousLinkClassName="page-link"
                                                                        nextClassName="page-item"
                                                                        nextLinkClassName="page-link"
                                                                        breakLabel="..."
                                                                        breakClassName="page-item"
                                                                        breakLinkClassName="page-link"
                                                                        containerClassName="pagination"
                                                                        activeClassName="active"
                                                                        renderOnZeroPageCount={null}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    </section>
                                                </div>
                                            ) : <NoDataFound text="No Data Found"/>
                                        }
                                    </div>
                                    </div>
                            )}               
                           </>
                        )
                    }
                </>
            )
          }
        </>
    )
}

export default ClaimHistory
